import Breadcrumb from "components/Common/Breadcrumb";
import DashboardLoader from "components/Loader/DashboardLoader";
import React, { useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { Row, Col, Card, CardBody, Badge, Button } from "reactstrap";
import { useGetProjectByIdQuery, useGetClientQuery, useUpdateProjectMutation, useGetAllWorkLogsQuery } from "store/features/client/clientManagementApi";
import { useGetAllDesignersQuery, useGetAllDevelopersQuery, useGetAllProjectManagersQuery } from "store/features/developer/developerManagementApi";
import EditProjectModal from "components/Modals/EditProjectModal";
import { useSelector } from "react-redux";
import { selectUser } from "store/features/auth/authSlice";

const ProjectDetails = () => {
  const user = useSelector(selectUser);

  const { id } = useParams();
  const { data: project, isLoading: projectLoading, refetch } = useGetProjectByIdQuery(id);
  const { data: allWorkLogs = [], isLoading: workLogsLoading } = useGetAllWorkLogsQuery();

  const { data: client, isLoading: clientLoading } = useGetClientQuery(project?.client, {
    skip: !project?.client
  });

  console.log("client", client);
  const { data: developers = [] } = useGetAllDevelopersQuery();
  const { data: designers = [] } = useGetAllDesignersQuery();
  const { data: projectManagers = [] } = useGetAllProjectManagersQuery();

  console.log("projectManagers projectManagers", projectManagers);

  const [editModalOpen, setEditModalOpen] = useState(false);

  const toggleEditModal = () => setEditModalOpen(!editModalOpen);

  const getStatusBadge = (status) => {
    const statusConfig = {
      'Pending': 'warning',
      'In Progress': 'primary',
      'Completed': 'success',
      'On Hold': 'danger'
    };
    return statusConfig[status] || 'secondary';
  };

  const getAssignedDevelopers = () => {
    if (!project?.assigned_project_manager || !projectManagers.length) return [];
    return projectManagers?.filter(dev => project.assigned_project_manager.includes(dev.id));
  };

  const getAssignedFrontendDevelopers = () => {
    if (!project?.assigned_frontend_dev || !developers.length) return [];
    return developers?.filter(dev => project.assigned_frontend_dev.includes(dev.id));
  };

  const getAssignedBackendDevelopers = () => {
    if (!project?.assigned_backend_dev || !developers.length) return [];
    return developers?.filter(dev => project.assigned_backend_dev.includes(dev.id));
  };

  const getAssignedDesigners = () => {
    if (!project?.assigned_designer || !designers.length) return [];
    return designers?.filter(dev => project.assigned_designer.includes(dev.id));
  };

  const handleProjectUpdate = () => {
    refetch(); // Refetch project data after update
    toggleEditModal();
  };

  const getFileViewLink = (fileUrl) => {
    if (!fileUrl) return null;
    return `${fileUrl}`;
  };

  const getPriorityBadge = priority => {
    const priorityConfig = {
      1: { color: "danger", text: "High" },
      2: { color: "warning", text: "Medium" },
      3: { color: "success", text: "Low" },
      "": { color: "secondary", text: "Not Set" },
    };
    const config = priorityConfig[priority] || priorityConfig[""];
    return `${config.text}`;
  };

  // Filter work logs by project ID
  const projectWorkLogs = useMemo(() => {
    if (!allWorkLogs || !project) return [];
    return allWorkLogs.filter(log =>
      log.project_id === project.id ||
      log.project_id === parseInt(project.id) ||
      log.project_id?.toString() === project.id?.toString()
    );
  }, [allWorkLogs, project]);

  if (projectLoading || clientLoading || workLogsLoading) {
    return <DashboardLoader />;
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumb
          title="Project Details"
          breadcrumbItem={
            <>
              <Link to="/clients">Clients</Link> / Project Details
            </>
          }
        />

        <Row>
          {/* Project Information */}

          <div className="mb-3 d-flex justify-content-end">

            {(user?.role == "super_admin" || user?.role == "admin" || user?.role == "marketing") ? (
              <Button color="primary" onClick={toggleEditModal}>
                <i className="fas fa-edit me-1"></i> Edit Project
              </Button>
            )
              : (
                // <Button color="primary" onClick={toggleEditModal}>
                //   <i className="fas fa-edit me-1"></i> Add Work Log
                // </Button>
                ""
              )}

          </div>

          <Col lg={8}>
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="card-title mb-0 text-primary" style={{ fontSize: "18px" }}>{project?.name}</h4>
                  <Badge color={getStatusBadge(project?.status)} className="fs-6">
                    {project?.status}
                  </Badge>
                </div>

                <Row>
                  {(user?.role == "super_admin" || user?.role == "admin") ? (
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Description</label>
                        <p className="text-muted mb-0">{project?.description || "No description provided"}</p>
                      </div>
                    </Col>)

                    :
                    (<Col lg={12}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Description</label>
                        <p className="text-muted mb-0">{project?.description || "No description provided"}</p>
                      </div>
                    </Col>

                    )}
                  {(user?.role == "super_admin" || user?.role == "admin") && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Budget</label>
                        <p className="text-muted mb-0">{project?.budget || "0.00"}</p>
                      </div>
                    </Col>

                  )}
                  <Col lg={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Start Date</label>
                      <p className="text-muted mb-0">{project?.start_date || "Not set"}</p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">End Date</label>
                      <p className="text-muted mb-0">{project?.end_date || "Not set"}</p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Progress</label>
                      <div className="progress mb-2">
                        <div
                          className="progress-bar"
                          role="progressbar"
                          style={{ width: `${project?.progress || 0}%` }}
                          aria-valuenow={project?.progress || 0}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        >
                          {project?.progress || 0}%
                        </div>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Priority</label>
                      <p className="text-muted mb-0">{getPriorityBadge(project?.priority_status)}</p>
                    </div>
                  </Col>

                  {/* <Col lg={6}>
                    <div className="mb-3">
                      <label className="form-label fw-semibold">Transactions</label>

                      {
                        project?.payment ?
                          project?.payment.map((payment, index) => (
                            <div key={payment.id}>
                              <small className="fs-6">
                                Payment {index + 1}:{" "}
                                <span className="fw-semibold">
                                  {payment.amount || "0.00"}
                                </span>
                              </small>
                            </div>
                          ))

                          : <p>No payments</p>


                      }
                    </div>
                  </Col> */}

                  {(user?.role == "super_admin" || user?.role == "admin") && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <label className="form-label fw-semibold">Transactions</label>

                        {project?.payment && project.payment.length > 0 ? (
                          <div className="">
                            {project.payment.map((payment, index) => (
                              <div
                                key={payment.id}
                                className="d-flex justify-content-between mb-1"
                              >
                                <div className="">
                                  <small className="fs-6">Payment {index + 1}:</small>
                                  <br />
                                  <small className="">{payment?.date}</small>
                                </div>
                                <small className="fw-semibold fs-6">
                                  {/* {parseFloat(payment.amount || 0).toFixed(0).toLocaleString()} */}
                                  {Number(parseFloat(payment.amount).toFixed(0)).toLocaleString()}
                                </small>
                              </div>
                            ))}

                            <hr className="my-2" />

                            {(() => {
                              const budget = parseFloat(project?.budget || 0);
                              const totalPaid = project.payment.reduce(
                                (sum, p) => sum + parseFloat(p.amount || 0),
                                0
                              );
                              const remaining = budget - totalPaid;

                              return (
                                <>
                                  <div className="d-flex justify-content-between align-items-center fs-5">
                                    <small className="fw-semibold text-success">Total Paid</small>
                                    <small className="fw-semibold text-success">

                                      {Number(totalPaid.toFixed(0)).toLocaleString()}
                                    </small>
                                  </div>

                                  <div className="d-flex justify-content-between align-items-center fs-5">
                                    <small
                                      className={`fw-semibold ${remaining <= 0 ? "text-success" : "text-danger"
                                        }`}
                                    >
                                      Remaining
                                    </small>
                                    <small
                                      className={`fw-semibold ${remaining <= 0 ? "text-success" : "text-danger"
                                        }`}
                                    >
                                      {Number(remaining.toFixed(0)).toLocaleString()}
                                    </small>
                                  </div>
                                </>
                              );
                            })()}
                          </div>
                        ) : (
                          <p className="text-muted mb-0">No payments</p>
                        )}
                      </div>
                    </Col>

                  )}




                </Row>

                {/* File Attachments Section */}

                {(user?.role == "super_admin" || user?.role == "admin") && (

                  <div className="mt-4">
                    <h5 className="card-title mb-3 text-primary" style={{ fontSize: "18px" }}>Project Documents</h5>
                    <Row>
                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Project Proposal</label>
                          <div>
                            {project?.project_proposal ? (
                              <a
                                href={getFileViewLink(project.project_proposal)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-file-pdf me-1"></i> View Proposal
                              </a>
                            ) : (
                              <span className="text-muted">No proposal uploaded</span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Contract</label>
                          <div>
                            {project?.contract ? (
                              <a
                                href={getFileViewLink(project.contract)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-file-contract me-1"></i> View Contract
                              </a>
                            ) : (
                              <span className="text-muted">No contract uploaded</span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Invoice 1</label>
                          <div>
                            {project?.invoice_1 ? (
                              <a
                                href={getFileViewLink(project.invoice_1)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-file-invoice me-1"></i> View Invoice 1
                              </a>
                            ) : (
                              <span className="text-muted">No invoice uploaded</span>
                            )}
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Invoice 2</label>
                          <div>
                            {project?.invoice_2 ? (
                              <a
                                href={getFileViewLink(project.invoice_2)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm"
                              >
                                <i className="fas fa-file-invoice me-1"></i> View Invoice 2
                              </a>
                            ) : (
                              <span className="text-muted">No invoice uploaded</span>
                            )}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                )}



                {/* <div className="mt-4">
                  <h5 className="card-title mb-3 text-primary" style={{ fontSize: "18px" }}>Work Logs</h5>
                  <Row>
                    {project?.work_logs && project.work_logs.length > 0 && (
                      <Col lg={12}>
                        <div className="mb-3">
                          <div className="">
                            {project.work_logs.map((log, index) => (
                              <div key={log.id || index} className="border rounded p-3 mb-2 border-bottom" style={{ backgroundColor: "#F2F2F2" }}>
                                <div className="d-flex justify-content-between">
                                  <strong>{log.user_name} ({log.user_role})</strong>
                                  <small className="text-muted">{log.date}</small>
                                </div>
                                <div className="mt-1">{log.log}</div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div> */}

                <div className="mt-4">
                  <h5 className="card-title mb-3 text-primary" style={{ fontSize: "18px" }}>Work Logs</h5>
                  <Row>
                    {projectWorkLogs.length > 0 ? (
                      <Col lg={12}>
                        <div className="mb-3">
                          <div className="">
                            {projectWorkLogs.map((log, index) => (
                              <div key={log.id || index} className="border rounded p-3 mb-3" style={{ backgroundColor: "#F2F2F2" }}>
                                {/* Header Row - Name, Date, Hours, Status */}
                                <div className="d-flex justify-content-between align-items-start mb-2">
                                  <div>
                                    <strong className="fs-6">{log.employer_name} ({log.employer_role})</strong>
                                  </div>
                                  <div className="text-end d-flex gap-3 align-items-center">
                                    <div className="text-muted small">
                                      {new Date(log.date).toLocaleDateString('en-US', {
                                        year: 'numeric',
                                        month: 'short',
                                        day: 'numeric'
                                      })}
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="badge bg-info">{log.hours_spent}h</span>
                                      <span className={`badge ${log.work_status === 'Completed' ? 'bg-success' :
                                        log.work_status === 'In Progress' ? 'bg-primary' :
                                          log.work_status === 'Pending' ? 'bg-warning' :
                                            'bg-danger'
                                        }`}>
                                        {log.work_status}
                                      </span>
                                    </div>
                                  </div>
                                </div>

                                {/* Title (if exists) */}
                                {log.title && (
                                  <div className="mb-2">
                                    <strong className="text-dark">{log.title}</strong>
                                  </div>
                                )}

                                {/* Work Summary */}
                                <div className="mt-2">
                                  <div className="text-dark">{log.work_summary}</div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Col>
                    ) : (
                      <Col lg={12}>
                        <div className="text-center py-4">
                          <i className="fas fa-clipboard-list fa-2x text-muted mb-2"></i>
                          <p className="text-muted mb-0">
                            {workLogsLoading ? "Loading work logs..." : "No work logs available for this project"}
                          </p>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>

              </CardBody>
            </Card>
          </Col>

          {/* Client Information & Team */}



          <Col lg={4}>
            {/* Client Card */}

            {(user?.role == "super_admin" || user?.role == "admin") && (
              <Card className="mb-4">
                <CardBody>
                  <h4 style={{ fontSize: "18px" }} className="card-title mb-3 text-primary">Client Information</h4>
                  {client ? (
                    <>
                      <div className="mb-2 d-flex gap-2">
                        <label className="form-label fw-semibold">Company Name:</label>
                        <p className="text-muted mb-0">{client.company_name}</p>
                      </div>
                      <div className="mb-2 d-flex gap-2">
                        <label className="form-label fw-semibold">Contact Person:</label>
                        <p className="text-muted mb-0">{client.contact_person || "N/A"}</p>
                      </div>
                      {/* <div className="mb-2 d-flex gap-2">
                      <label className="form-label fw-semibold">Email:</label>
                      <p className="text-muted mb-0">{client.user_info?.personal_email || "N/A"}</p>
                    </div> */}
                      <div className="mb-2 d-flex gap-2">
                        <label className="form-label fw-semibold">Phone:</label>
                        <p className="text-muted mb-0">{client.contact_number || "N/A"}</p>
                      </div>
                      <div className="mb-2 d-flex gap-2">
                        <label className="form-label fw-semibold">Address:</label>
                        <p className="text-muted mb-0">{client.address || "N/A"}</p>
                      </div>
                      <div className="mb-2 d-flex gap-2">
                        <label className="form-label fw-semibold">Notes:</label>
                        <p className="text-muted mb-0">{client.notes || "N/A"}</p>
                      </div>
                    </>
                  ) : (
                    <p className="text-muted">No client information available</p>
                  )}
                </CardBody>
              </Card>

            )}
            {/* Assigned Team Card */}
            <Card>
              <CardBody>
                <h4 className="card-title mb-3 text-primary" style={{ fontSize: "18px" }}>Assigned Team</h4>
                <h5 className="card-title mb-3 text-dark">Project Manager</h5>
                {getAssignedDevelopers().length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {getAssignedDevelopers().map(dev => (
                      <div key={dev.id} className="d-flex align-items-center justify-content-between p-2 border rounded">
                        <div>
                          <h6 className="mb-0 fs-14">{dev.nickname}</h6>
                          {/* <small className="text-muted">{dev.personal_email}</small> */}
                        </div>
                        <Badge color="light" className="text-dark">
                          {dev.role}
                        </Badge>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No team members assigned</p>
                )}
                {/* </CardBody>
              <CardBody> */}
                <h5 className="card-title mb-3 mt-3 text-dark">FrontEnd Developer</h5>
                {getAssignedFrontendDevelopers().length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {getAssignedFrontendDevelopers().map(dev => (
                      <div key={dev.id} className="d-flex align-items-center justify-content-between p-2 border rounded">
                        <div>
                          <h6 className="mb-0 fs-14">{dev.nickname}</h6>
                          {/* <small className="text-muted">{dev.personal_email}</small> */}
                        </div>
                        <Badge color="light" className="text-dark">
                          {dev.role}
                        </Badge>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No team members assigned</p>
                )}
                {/* </CardBody>
              <CardBody> */}
                <h5 className="card-title mb-3  mt-3 text-dark">Backend Developer</h5>

                {getAssignedBackendDevelopers().length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {getAssignedBackendDevelopers().map(dev => (
                      <div key={dev.id} className="d-flex align-items-center justify-content-between p-2 border rounded">
                        <div>
                          <h6 className="mb-0 fs-14">{dev.nickname}</h6>
                          {/* <small className="text-muted">{dev.personal_email}</small> */}
                        </div>
                        <Badge color="light" className="text-dark">
                          {dev.role}
                        </Badge>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No team members assigned</p>
                )}
                {/* </CardBody>
              <CardBody> */}
                <h5 className="card-title mb-3  mt-3 text-dark">Designer</h5>
                {getAssignedDesigners().length > 0 ? (
                  <div className="d-flex flex-column gap-2">
                    {getAssignedDesigners().map(dev => (
                      <div key={dev.id} className="d-flex align-items-center justify-content-between p-2 border rounded">
                        <div>
                          <h6 className="mb-0 fs-14">{dev.nickname}</h6>
                          {/* <small className="text-muted">{dev.personal_email}</small> */}
                        </div>
                        <Badge color="light" className="text-dark">
                          {dev.role}
                        </Badge>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-muted">No team members assigned</p>
                )}
              </CardBody>
            </Card>
          </Col>


        </Row>

        {/* Edit Project Modal */}
        {project && (
          <EditProjectModal
            isOpen={editModalOpen}
            toggle={toggleEditModal}
            project={project}
            client={client}
            onProjectUpdate={handleProjectUpdate}
          />
        )}
      </div>
    </div>
  );
};

export default ProjectDetails;